import React from "react";
import { Box } from "@material-ui/core";
import { CustomCard } from "../../CustomCard";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

const UnitesProperetyComponentSkeleton = ({ numberSkeletonCards }) => {
  const styles = useStyles();
  const skeletonCards = Array.from(
    { length: numberSkeletonCards },
    (_, index) => (
      <CustomCard
        key={index}
        boxShadow="xs"
        borderRadius="sm"
        classes={styles.wapperunitCardItemSkeleton}
      >
        <Box className={styles.containerImage}></Box>
        <Box className={styles.containerBodyCard}>
          <Box className={styles.containerTopSection}>
            <Box className={styles.containerUnitPrice}>
              <Box className={styles.containerPriceTitle}>
                <Skeleton variant="text" width={72} height={30} />
                <Skeleton variant="text" width={29} height={30} />
              </Box>
              <Skeleton variant="text" width={25} height={30} />
            </Box>
            <Skeleton variant="text" width={150} height={28} />
            <Box className={styles.containerUnitTypeAndCopy}>
              <Box className={styles.containerCustomCopyToBoard}>
                <Skeleton variant="text" width={57} height={30} />
                <Skeleton variant="text" width={25} height={30} />
              </Box>
              <Skeleton variant="text" width={57} height={30} />
            </Box>
            <Skeleton variant="text" width={200} height={20} />
          </Box>
          <Box className={styles.containerBottomSection}>
            <Box className={styles.containerInfoSection}>
              <Skeleton
                style={{ borderRadius: "16px" }}
                width="42px"
                height="33px"
                variant="text"
              />
              <Skeleton
                style={{ borderRadius: "16px" }}
                width="80px"
                height="33px"
                variant="text"
              />
              <Skeleton variant="text" width={57} height={30} />
            </Box>
            <Box className={styles.detailsUnits}>
              <Box className={styles.containerUnitItem}>
                <Skeleton variant="text" width={25} height={25} />
                <Skeleton variant="text" width={20} height={25} />
              </Box>
              <Box className={styles.containerUnitItem}>
                <Skeleton variant="text" width={25} height={25} />
                <Skeleton variant="text" width={25} height={25} />
              </Box>
              <Box className={styles.containerUnitItem}>
                <Skeleton variant="text" width={25} height={25} />
                <Skeleton variant="text" width={30} height={25} />
              </Box>
            </Box>
          </Box>
        </Box>
      </CustomCard>
    )
  );
  return <>{skeletonCards}</>;
};

export default UnitesProperetyComponentSkeleton;
